exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-suggestion{display:inline-block;list-style:none;cursor:pointer}.ebx-suggestion--selected,.ebx-suggestion:hover{text-decoration:underline}", ""]);
